import { YStack, View } from 'tamagui'
import { useMemo } from 'react'
import { useModules } from '@hooks/useModules'
import { ModuleContainer } from './ModuleContainer'
import { ICourseModulesNodes } from '@dtos/Course'

const hasContent = (module: ICourseModulesNodes): boolean => {
  // Check if module has content
  if (module.courseContentsCount > 0) return true

  // Check if any submodule has content
  if (module.courseModules?.length > 0) {
    return module.courseModules.some((submodule) => hasContent(submodule))
  }

  return false
}

export function CourseModules() {
  const { modules, onLoadMore } = useModules()

  const filteredAvailableModules = useMemo(() => {
    if (!modules) return []
    return modules.nodes.filter(
      (module) => module.available !== false && hasContent(module),
    )
  }, [modules])

  if (!modules) return null
  return (
    <YStack
      bg="$background-100"
      p={'$size.spacing-xs'}
      $gtSm={{
        padding: '$size.spacing-md',
        paddingTop: 0,
      }}
      $gtMd={{
        padding: '$size.spacing-xsl',
        paddingTop: 0,
        paddingBottom: 0,
      }}
      id="course-modules"
    >
      {filteredAvailableModules.map((module, index) => {
        if (module.available === false) return null
        const thisModuleHasContent = hasContent(module)
        const isLastModule = index !== filteredAvailableModules.length - 1

        const availableSubmodules =
          module.courseModules?.filter(
            (submodule) =>
              submodule.available !== false && hasContent(submodule),
          ) || []

        const moduleHasContent = module.courseContentsCount > 0
        const needPaddingBottom = moduleHasContent

        return (
          <View key={module.id}>
            <ModuleContainer
              module={module}
              isLastModuleOfData={isLastModule}
              displayBorder={index === 0}
              onLoadMoreCallBack={onLoadMore}
              isLastSubmodule={needPaddingBottom}
            />
            {availableSubmodules.map((submodule, index) => {
              const isLastSubmodule = index === availableSubmodules.length - 1

              const isFirstSubmodule = index === 0
              return (
                <ModuleContainer
                  key={submodule.id}
                  module={submodule}
                  parentCourseModuleId={submodule.parentCourseModule?.id}
                  displayBorder
                  isLastSubmodule={isLastSubmodule}
                  fatherHasContent={thisModuleHasContent && isFirstSubmodule}
                />
              )
            })}
          </View>
        )
      })}
    </YStack>
  )
}
